import {CancelablePromise, OpenAPI} from "../generated";

export class GpsrCustomService {
    /**
     * Upload files
     * Upload gpsr product files to fire store storage
     * @param files Array of files to upload
     * @returns any Success gpsr product upload files
     * @throws ApiError
     */
    public static gpsrProductUploadFiles(
        files: File[]
    ): CancelablePromise<Record<string, any>> {
        // Create FormData manually
        // Use 'files[]' for array of files (PHP/Symfony convention)
        const formData = new FormData();
        files.forEach((file) => {
            formData.append("files[]", file);
        });

        // Use fetch directly
        return new CancelablePromise((resolve, reject) => {
            fetch(`${OpenAPI.BASE}/v2/api/gpsr/files`, {
                method: "POST",
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("token")}`,
                },
                body: formData,
            })
                .then((response) => response.json())
                .then((data) => {
                    if (data.success === false) {
                        reject(new Error(data.error || 'Upload failed'));
                    } else {
                        resolve(data);
                    }
                })
                .catch(reject);
        });
    }

    /**
     * Download product documentation
     * Downloads product documentation (ZIP or PDF)
     * @param productId ID of the product to download documentation for
     * @param productName Name of the product (used for the downloaded file name)
     * @returns Promise that resolves when download is complete
     * @throws Error if download fails
     */
    public static gpsrProductDownloadDocumentation(
        productId: string,
        productName: string
    ): CancelablePromise<void> {
        return new CancelablePromise(async (resolve, reject) => {
            try {
                const response = await fetch(
                    `${OpenAPI.BASE}/v2/api/gpsr/product/${productId}/download`,
                    {
                        method: "GET",
                        headers: {
                            Authorization: `Bearer ${localStorage.getItem("token")}`,
                        },
                    }
                );

                if (!response.ok) {
                    const errorText = await response.text();
                    throw new Error(errorText || "Network response was not ok");
                }

                const blob = await response.blob();
                if (blob.size === 0) {
                    throw new Error("Received empty file");
                }

                // Determine file extension based on content type
                const contentType = response.headers.get("content-type") || "";
                let extension = ".zip";
                if (contentType.includes("application/pdf")) {
                    extension = ".pdf";
                } else if (contentType.includes("application/zip")) {
                    extension = ".zip";
                }

                const fileName = productName.toLowerCase().trim().replace(/[\s\W-]+/g, '-').replace(/^-+|-+$/g, '');

                const url = window.URL.createObjectURL(blob);
                const a = document.createElement("a");
                a.href = url;
                a.download = `${fileName}${extension}`;
                document.body.appendChild(a);
                a.click();
                a.remove();
                window.URL.revokeObjectURL(url);

                resolve();
            } catch (error) {
                reject(error);
            }
        });
    }
}